import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ApiKeyButton } from 'components/system/CustomizedButton';
import colors from 'styles/colors';

const style = process.env.ACCOUNT_DEACTIVATE === 'true'
  ? { borderBottom: `1px solid ${colors.border.border_5p}` }
  : {};

const SeeApiKey = () => (
  <Box
    sx={{
      padding: '24px 0',
      ...style,
    }}
  >
    <Box sx={{ maxHeight: '76px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          variant="h5"
          sx={{ color: colors.text.primary }}
        >
          Your personal API token
        </Typography>

      </Box>
    </Box>
    <Box sx={{ pt: '24px' }}>
      <ApiKeyButton />
    </Box>
  </Box>
);

export default SeeApiKey;
